var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

var ActionTypes = AppActionConstants.ActionTypes.genres;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
var GenresStore = assign({}, ModelStore, {
	getResourceListData: function () {
		//return this._mutateAttributes();
		return _resourceListData;
	}
});

/**
 * Event Listeners
 */
GenresStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'GENRES_LISTED':
			_resourceListData = action.data;

			GenresStore.emitChange();
			break;
	}
});

module.exports = GenresStore;
